export default "__VITE_ASSET__BQq2wD$Z__"